import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { BoardAdminComponent } from './board-admin/board-admin.component';
import { ClaveComponent } from './clave/clave.component';
import { ConfirmarCorreoComponent } from './confirmar-correo/confirmar-correo.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { AuthGuard } from './guards/auth.guard';
import { EnvironmentGuard } from './guards/environment.guard';
import { NoLoginGuard } from './guards/noLogin.guard';
import { InfoLegalComponent } from './info-legal/info-legal/info-legal.component';
import { LoginComponent } from './login/login.component';
import { RaizComponent } from './raiz/raiz.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

const routes: Routes = [
  {
    path: '', component: RaizComponent,
    children: [
      { path: 'login', component: LoginComponent, canActivate: [NoLoginGuard] },
      { path: 'forgot-password', component: ForgotPasswordComponent, canActivate: [NoLoginGuard] },
      { path: 'reset-password/:identificador', component: ResetPasswordComponent, canActivate: [NoLoginGuard] },
      { path: 'confirmar-correo/:identificador', component: ConfirmarCorreoComponent, canActivate: [NoLoginGuard] },
      {
        path: 'info',
        children: [
          { path: 'aviso-legal', component: InfoLegalComponent },
          { path: 'politica-privacidad', component: InfoLegalComponent },
          { path: 'proteccion-de-datos', component: InfoLegalComponent },
          { path: 'terminos-registro-general', component: InfoLegalComponent },
          { path: 'terminos-seleccion-personal', component: InfoLegalComponent },
        ]
      },
      { path: 'admin', component: BoardAdminComponent, canActivate: [AuthGuard, EnvironmentGuard], data: { allowedClients: ['emvs', 'gmu'] } },
      { path: 'clave/:id', component: ClaveComponent, canActivate: [EnvironmentGuard], data: { allowedClients: ['emvs', 'gmu'] } }
    ]
  },
  { path: '**', redirectTo: 'login' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: true,
    anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }